/* MUI */
import { Box, Card, CardContent } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Objects  */
import {
    Application,
    ApplicationCategoryAndSubCategory,
    ApplicationIcon,
    ApplicationName
} from 'objects/Application';

/* React */
import React from 'react';

export const UserDetailsAppHeadlineCard = ({ app }) => {
    const theme = useTheme();
    return (
        <Box
            className="noBreak"
            data-testid="userDetailsAppHeadlineCard"
            display="flex"
            justifyContent="center"
            p="64px"
            width="100%"
            sx={{
                backgroundColor: 'background.white',
                backgroundImage: `linear-gradient(${theme.palette.background.contractTableLight} 50%, ${theme.palette.background.contractTable} 50%)`
            }}
        >
            <Card
                variant="outlined"
                sx={{
                    borderColor: 'border.userDetailsAppHeadlineCard',
                    padding: '16px',
                    width: '33%'
                }}
            >
                <CardContent
                    style={{ justifyContent: 'center', textAlign: 'center' }}
                >
                    <Application data={app}>
                        <Box>
                            <ApplicationIcon
                                classNameForNoImageInside="bigIconText"
                                sx={{ height: '32px', width: '32px' }}
                            />
                        </Box>
                        <Box
                            py="16px"
                            display="flex"
                            justifyContent="center"
                            data-testid="userDetailsAppHeadlineCardAppName"
                        >
                            <ApplicationName noTruncate className="bigText" />
                        </Box>
                        <ApplicationCategoryAndSubCategory
                            noTruncate
                            size="normal"
                        />
                    </Application>
                </CardContent>
            </Card>
        </Box>
    );
};
